
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.281 12.378a.782.782 0 01-.577.227c-.17 0-.328-.036-.474-.107a1.925 1.925 0 01-.468-.34L4.727 9.273 1 13l-.707-.707 3.09-3.09h-.892c-.486 0-.856-.13-1.11-.392C1.127 8.55 1 8.161 1 7.643v-2.66c0-.518.127-.909.381-1.172.254-.263.624-.395 1.11-.395h2.055c.069 0 .126-.02.172-.062L7.762.488c.18-.174.336-.299.471-.375A.92.92 0 018.69 0c.239 0 .434.082.588.247.153.165.23.362.23.591v2.24L12.293.293 13 1 9.508 4.492V11.8a.782.782 0 01-.227.577z","fill":"#fff"}})])
          )
        }
      }
    